import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SnackbarService } from 'src/app/layout/snackbars/snackbar.service';
import { SpinnerService } from 'src/app/layout/spinner.service';
import { RequestsService } from '../requests.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';
import { SanitizeHtmlPipe } from '../../auth/pipes/sanitizehtml.pipe';

@Component({
    selector: 'app-assign-dialog',
    templateUrl: './assign-dialog.component.html',
    styleUrls: ['./assign-dialog.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, MatButton, MatIcon, DatePipe, SanitizeHtmlPipe]
})
export class AssignDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<AssignDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private requestService: RequestsService,
    private spinnerService: SpinnerService,
    private snackbarService: SnackbarService
  ) { }

  assignGroup: UntypedFormGroup;
  internalRequestId: number;

  ngOnInit(): void {
    this.assignGroup = new UntypedFormGroup({
      requestId: new UntypedFormControl(null, [
        Validators.required,
        Validators.minLength(36),
        Validators.maxLength(36),
      ]),
    });
  }

  assignMessage(): void {
    const requestId = this.assignGroup.value.requestId;
    const messageId = this.data.message.id;


    this.spinnerService.startSpinner();
    this.requestService.getMessageByRequestId(requestId).subscribe(
      (data: any) => {
        if (!data) {
          this.spinnerService.stopSpinner();
          this.snackbarService.openErrorMessage('No request with this ID was found.');
        } else {
          this.internalRequestId = data.id;

          this.requestService
            .assignMessage(this.internalRequestId, messageId)
            .subscribe(
              () => {
                this.spinnerService.stopSpinner();
                this.snackbarService.openSuccess();
                this.dialogRef.close();
              },
              (error: any) => {
                this.spinnerService.stopSpinner();
                this.snackbarService.openError(error.status);
              }
            );
        }
      },

      (error: any) => {
        this.snackbarService.openError(error.status);
      }
    );
  }

  close(): void {
    this.spinnerService.stopSpinner();
    this.dialogRef.close();
  }
}
